var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.uploadToShow
    ? _c("div", { staticClass: "popup", attrs: { id: "uploadToTree" } }, [
        _c("div", { staticClass: "content", attrs: { id: "pleaseSelect" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.popup.cloudTransferPopup.pleaSelect"))
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closeSelect()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "aimTree",
              staticClass: "task-content"
            },
            [
              _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                !_vm.model.length && !_vm.loading
                  ? _c(
                      "div",
                      {
                        staticClass: "nondrive-des",
                        on: {
                          click: function($event) {
                            return _vm.toAddCloudPage()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\r\n                " +
                            _vm._s(
                              _vm.$t(
                                "language.popup.cloudTransferPopup.addValidCloud"
                              )
                            ) +
                            "\r\n            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tree-nodes", attrs: { id: "treeNodes" } },
                  _vm._l(_vm.model, function(item, index) {
                    return _c(
                      "ul",
                      { key: index },
                      [
                        _c("tree", {
                          ref: "tree",
                          refInFor: true,
                          attrs: {
                            model: item,
                            index: index,
                            treeShow: true,
                            transferAimFlag: _vm.createFolder
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "task-footer" }, [
            _c(
              "button",
              {
                staticClass: "task-button",
                on: {
                  click: function($event) {
                    return _vm.cloudSubmit()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18d18375", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18d18375","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/remote_task_popups/upload_to_tree_popup.vue
// module id = null
// module chunks = 